import React, { createContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { GetBranchInfoById } from '../../../../../../Services';

const LeadXchangeDataContext = createContext({
  leadXchangeClaimLead: () => {},
  actionableItems: { selectedIds: [], action: null },
  userInfo: { userId: null, userName: null, branchName: null, name: null },
});

const LeadXchangeDataProvider = ({ children }) => {
  const [actionableItems, setActionableItems] = useState({
    selectedIds: [],
    action: null,
  });

  const [userInfo, setUserInfo] = useState({
    userId: null,
    userName: null,
    branchName: null,
    name: null,
    branchId: null,
  });

  const loginResponse = useSelector((state) => state.login.loginResponse);

  const getBranchInfoById = async (branchId) => {
    const res = await GetBranchInfoById(branchId);
    if (!(res && res.status && res.status !== 200)) {
      setUserInfo((prev) => ({
        ...prev,
        branchName: res.branchName,
      }));
    }
  };

  useEffect(() => {
    if (loginResponse) {
      const { userName, userId, fullName, branchId } = loginResponse;
      setUserInfo((prev) => ({
        ...prev,
        userId,
        userName,
        branchId,
        name: fullName,
      }));

      if (branchId) {
        getBranchInfoById(branchId);
      }
    }
  }, [loginResponse]);


  return (
    <LeadXchangeDataContext.Provider
      value={{
        loginResponse,
        actionableItems,
        setActionableItems,
        userInfo,
      }}
    >
      {children}
    </LeadXchangeDataContext.Provider>
  );
};

export default LeadXchangeDataProvider;

export const useLeadXchangeData = () =>
  React.useContext(LeadXchangeDataContext);
